import React, { useState } from "react";

import Category from "./Category";
import { actions, assets, liabilities, result } from './labels';
import { parseFullAmount } from "../common-helpers";
import './net-worth.css'
import { Button } from "../Button";

export const NetWorth: React.FC = () => {
	const resetHandlers: (() => void)[] = [];
	const [ assetsWorth, setAssetsWorth ] = useState<number>(0);
	const [ liabilitiesWorth, setLiabilitiesWorth ] = useState<number>(0);
	const [assetsAmountList, setAssetsAmountList] = useState(Array.from({ length: assets.categories.left.length + assets.categories.right.length }, () => 0));
	const [liabilitiesAmountList, setLiabilitiesAmountList] = useState(Array.from({ length: assets.categories.left.length + assets.categories.right.length }, () => 0));

  const updateAssetCategory = (amount: number, id: number) => {
    const updatedVList = assetsAmountList.map((val, i) => (+id === i ? amount : val));
    setAssetsAmountList(updatedVList);
    setAssetsWorth(updatedVList.reduce((a, b) => a + b, 0));
  };

  const updateLiabilityCategory = (amount: number, id: number) => {
    const updatedVList = liabilitiesAmountList.map((val, i) => (+id === i ? amount : val));
    setLiabilitiesAmountList(updatedVList);
    setLiabilitiesWorth(updatedVList.reduce((a, b) => a + b, 0));
  };

  const clearValues = () => {
    setAssetsAmountList(assetsAmountList.map(() => 0));
    setLiabilitiesAmountList(liabilitiesAmountList.map(() => 0));
    setAssetsWorth(0);
		setLiabilitiesWorth(0);
  };
	const clear = () => {
		clearValues();
		resetHandlers.forEach(( reset ) => reset());
	}

	return (
		<div className="container__netWorth">
			<div className="netWorth-section">
				<div className="netWorth-section-title">{assets.title}</div>
				<div className="netWorth-block">
					<div className="netWorth-categories-left">
					{assets.categories.left && assets.categories.left.map(el => (
            <Category
              {...el}
              categoryIndex={el.index}
              updateCategory={updateAssetCategory}
              resetHandlers={resetHandlers}
							key={`assets-${el.index}`}
            />
          ))}
					</div>
					<div className="netWorth-categories-right">
					{assets.categories.right && assets.categories.right.map(el => (
            <Category
              {...el}
              categoryIndex={el.index}
              updateCategory={updateAssetCategory}
              resetHandlers={resetHandlers}
							key={`assets-${el.index}`}
            />
          ))}
					</div>
				</div>
			</div>
			<div className="netWorth-section">
				<div className="netWorth-section-title">{liabilities.title}</div>
				<div className="netWorth-block">
					<div className="netWorth-categories-left">
					{liabilities.categories.left && liabilities.categories.left.map(el => (
            <Category
              {...el}
              categoryIndex={el.index}
              updateCategory={updateLiabilityCategory}
              resetHandlers={resetHandlers}
							key={`liabilities-${el.index}`}
            />
          ))}
					</div>
					<div className="netWorth-categories-right">
					{liabilities.categories.right && liabilities.categories.right.map(el => (
            <Category
              {...el}
              categoryIndex={el.index}
              updateCategory={updateLiabilityCategory}
              resetHandlers={resetHandlers}
							key={`liabilities-${el.index}`}
            />
          ))}
					</div>
				</div>
			</div>
			<div className="netWorth-result-block">
				<div className="netWorth-result-description-title">{result.title}</div>
				<div className="netWorth-result-value-total">{`${parseFullAmount(assetsWorth - liabilitiesWorth)}`}</div>
				<div className="netWorth-result-description">
					{result.assets}
					<span className="netWorth-result-value">{`${parseFullAmount(assetsWorth)}`}</span>
				</div>
				<div className="netWorth-result-description">
					{result.liabilities}
					<span className="netWorth-result-value">{`${parseFullAmount(-liabilitiesWorth)}`}</span>
				</div>
			</div>
			<Button
				label={actions.clear}
				className="primary-button netWorth-btn"
				onClickHandler={clear}
			/>
		</div>
	);
}
